import FootballRules from "../list";
import Tree from "../../../../structure/tree";
import Ruleset from "../../enums/ruleset";

const NJCAA2021Rules = {
    id: Ruleset.NJCAA2021.code,
    rules: new Tree(FootballRules.General.PlayEnd.Default, [
        new Tree(FootballRules.Offensive.Rush.RecordStats, [
            new Tree([
                FootballRules.Offensive.Rush.FieldChange,
                FootballRules.General.ChangeDown
            ])
        ])
    ])
};

export default NJCAA2021Rules;
